module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$vuetify.breakpoint.lg ? _vm.drawer = false : _vm.drawer = _vm.drawer) ? _c('v-navigation-drawer', {
    staticClass: "side-bar",
    attrs: {
      "disable-resize-watcher": "",
      "floating": "",
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list-tile', {
    staticClass: "side-bar-search"
  }, [_c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-list', {
    staticClass: "mt-2",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.filteredLinks), function(item, index) {
    return _c('v-list-tile', {
      key: index,
      attrs: {
        "to": ("/" + _vm.language + (item.path))
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$lang.header[item.title]))])], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "py-2",
    attrs: {
      "color": "primary",
      "app": "",
      "light": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "color": "white--text hidden-lg-and-up"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    staticClass: "logo px-0 mr-2",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.global.projectName) + "\n      ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "layout row wrap pl-2 hidden-md-and-down"
  }, _vm._l((_vm.approvedLinks), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "px-2",
      attrs: {
        "tag": "li",
        "to": ("/" + _vm.language + (item.path)),
        "active-class": "active"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header[item.title]))])
  }), 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('router-link', {
    staticClass: "elevation-0 log-out white--text",
    attrs: {
      "tag": "v-btn",
      "to": "/log-out"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.header.logout) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9090f0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 431
// module chunks = 35